<template>
  <div>
    <Modal v-model="visible" title="变更归属" :footer-hide="true" :mask-closable="false" class="my-modal top">
      <Form ref="form" :model="form" :label-width="100" class="modal-form">
        <FormItem label="保单号">
          {{ form.policyNo }}
        </FormItem>
        <FormItem label="原归属机构">
          {{ form.organizationName }}
        </FormItem>
        <FormItem label="原归属团队">
          {{ form.groupName }}
        </FormItem>
        <FormItem label="原归属业务员"> {{ form.staffNo }}/{{ form.salemanName }} </FormItem>
        <FormItem prop="salesmanId" label="新归属" :rules="$units.formRule.required('请选择归属业务员', 'change')">
          <lzSelect v-model="form.salesmanId" placeholder="请输入业务员姓名搜索" ref="salesmanSelect" :remote-method="getUserList" :transfer="true">
            <template slot-scope="{ list }">
              <Option v-for="(item, index) in list" :value="item.id" :key="index">
                <i class="dian" :class="{ red: item.workingState == 0 || item.isSus == 1 }"></i>
                {{ item.orgName }}/{{ item.groupName }}/{{ item.name }}<template v-if="item.staffNo">({{ item.staffNo }})</template>
              </Option>
            </template>
          </lzSelect>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="ok" :loading="loading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import lzSelect from '@/components/commons/lzSelect';
export default {
  components: {
    lzSelect
  },
  data() {
    return {
      form: {},
      title: '',
      loading: false,
      list: [],
      searchLoading: false,
      visible: false
    };
  },

  methods: {
    open(data, title) {
      this.visible = true;
      this.title = title;
      this.loading = false;
      const form = JSON.parse(JSON.stringify(data));
      delete form.salesmanId;
      this.form = form;
      this.$nextTick(() => {
        // 清除验证信息
        this.$refs.form &&
          this.$refs.form.fields.forEach(item => {
            item.validateState = '';
            item.validateMessage = '';
          });
      });
    },

    getUserList(keyword) {
      if (!keyword) {
        return;
      }
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      const params = {
        orgId: userInfo.organId,
        userName: keyword
      };
      return this.$http({
        url: '/buz/userBase/listUsersByOrgIdAndName',
        type: 'GET',
        data: params
      }).then(res => {
        return res.data;
      });
    },

    ok() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        this.loading = true;
        this.$http({
          url: '/buz/policy/changeBelong',
          type: 'POST',
          data: {
            policyNo: this.form.policyNo,
            changeType: 3, //划单方式 （1 远程划单#从产品中心划单  2本地划单（变更归属）3 团险）
            salesmanId: this.form.salesmanId
          }
        })
          .then(res => {
            this.loading = false;
            this.visible = false;
            this.$notice.success('操作成功');
            this.$emit('success');
          })
          .catch(e => {
            this.loading = false;
          });
      });
    }
  }
};
</script>

<style lang="scss">
.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
  &.red {
    background: #e3461f;
  }
}
</style>
